:host {
  padding: 0;
  width: 100%;
  font-size: 1rem;
  position: relative;
  display: block;
}

@supports (container-type: inline-size) {
  :host {
    container-type: inline-size;
    container-name: wrapper;
  }
}

.wrapper {
  display: flex;
}

@media (min-width: 768px) {
  .wrapper {
    justify-content: center;
    align-items: center;
  }
}

.icon-container {
  display: flex;
  flex-direction: column;
  width: 312px;
}

@media (min-width: 768px) {
  .icon-container {
    flex-direction: row;
    flex-wrap: wrap;
    width: unset;
    max-width: 700px;
  }
}

@supports not (container-type: inline-size) {
  @media (min-width: 1440px) {
    .icon-container {
      flex-direction: row;
      flex-wrap: unset;
      justify-content: center;
    }
  }
}

@container wrapper (min-width: 1200px) {
  .icon-container {
    flex-direction: row;
    flex-wrap: unset;
    justify-content: center;
  }
}

.icon {
  display: flex;
  align-items: center;
  padding: 16px;
  text-decoration: none;
  min-width: 200px;
}

.icon:hover .lottie-animation path {
  stroke: var(--sdx-color-int-blue--active);
  fill: var(--sdx-color-int-blue--active);
}

.icon:hover .icon-description {
  color: var(--sdx-color-int-blue--active);
}

@media (min-width: 1024px) {
  .icon {
    flex-direction: column;
  }
}

@media (min-width: 1024px) {
  .icon {
    flex-direction: column;
  }
}
.lottie-animation {
  width: 28px;
  height: 28px;
}

@media (min-width: 1024px) {
  .lottie-animation {
    width: 42px;
    height: 42px;
  }
}

.lottie-animation path {
  stroke: var(--sdx-color-sc-navy);
  fill: var(--sdx-color-sc-navy);
}

.icon-description {
  font-size: 20px;
  font-weight: 600;
  padding-left: 8px;
  color: var(--sdx-color-sc-navy);
}

@media (min-width: 1024px) {
  .icon-description {
    padding-top: 8px;
    padding-left: unset;
  }
}
